import React, { useState } from 'react';

import './Pagination.style.scss'
const Pagination = ({ totalItems, itemsPerPage, onPageChange }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const maxPageButtons = 5;

    // Create an array of page numbers to be displayed
    const calculatePageNumbers = () => {
        let startPage, endPage;

        if (totalPages <= maxPageButtons) {
            startPage = 1;
            endPage = totalPages;
        } else {
            if (currentPage <= Math.ceil(maxPageButtons / 2)) {
                startPage = 1;
                endPage = maxPageButtons;
            } else if (currentPage + Math.floor(maxPageButtons / 2) >= totalPages) {
                startPage = totalPages - maxPageButtons + 1;
                endPage = totalPages;
            } else {
                startPage = currentPage - Math.floor(maxPageButtons / 2);
                endPage = currentPage + Math.floor(maxPageButtons / 2);
            }
        }

        return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
    };

    const pageNumbers = calculatePageNumbers();
    // Create an array of page numbers
    const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

    // Handle page click
    const handleClick = (pageNumber) => {
        setCurrentPage(pageNumber);
        onPageChange(pageNumber);
    };

    // Handle previous page click
    const handlePrev = () => {
        if (currentPage > 1) {
            setCurrentPage((prevPage) => prevPage - 1);
            onPageChange(currentPage - 1);
        }
    };

    // Handle next page click
    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage((prevPage) => prevPage + 1);
            onPageChange(currentPage + 1);
        }
    };

    return (
        <div className="paginationContainer">
            <button
                className={`paginationButton ${currentPage === 1 ? 'disabled' : ''}`}
                onClick={handlePrev}
                disabled={currentPage === 1}
            >
                &lt;
            </button>

            {pageNumbers.map((page) => (
                <button
                    key={page}
                    className={`paginationButton ${currentPage === page ? 'active' : ''}`}
                    onClick={() => handleClick(page)}
                >
                    {page}
                </button>
            ))}

            <button
                className={`paginationButton ${currentPage === totalPages ? 'disabled' : ''}`}
                onClick={handleNext}
                disabled={currentPage === totalPages}
            >
                &gt;
            </button>
        </div>
    );
};

export default Pagination;